import { createContext, useContext } from 'react';
import type { CurrentUserDto, ProjectListItemDto } from '@/types/api';

export interface ProjectScope {
  project: ProjectListItemDto;
  projects: ReadonlyArray<ProjectListItemDto>;
  user: CurrentUserDto;
}

const ProjectContext = createContext<ProjectScope | null>(null);

export const ProjectProvider = ProjectContext.Provider;

export function useProjectScope(): ProjectScope {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error('useProjectScope must be used within a ProjectGuard');
  }
  return ctx;
}

export function useProjectScopeOptional(): ProjectScope | null {
  return useContext(ProjectContext);
}

export function hasCapability(user: CurrentUserDto, capability: string): boolean {
  return user.capabilities.includes(capability);
}
